export enum FileWatcherEventTypeEnum {
    Add = 'add',
    AddDone = 'add_done',
    Change = 'change',
    Delete = 'delete',
}
